import { createSelector } from '@ngrx/store';
import { IVisorState } from 'app/visor/shared/models/mapModels';
import { getVisorState } from './config-leaflet.selector';

export const getHistoricalGpsState = createSelector(getVisorState, (state: IVisorState) => state.historicalGps.historicalGps);
export const getHistoricalRequest = createSelector(getVisorState, (state: IVisorState) => state.historicalGps.payloadRequest);
export const loadingHistoricalGpsState = createSelector(getVisorState, (state: IVisorState) => state.historicalGps.loading);
export const cleanHistoricalGpsState = createSelector(getVisorState, (state: IVisorState) => state.historicalGps.isEmpty);
